<template>
  <v-row justify="center" v-if="detalle">
    <v-dialog v-model="dialog" scrollable width="auto" :fullscreen="$vuetify.breakpoint.mobile">
      <v-form ref="formDivider" v-model="valid" lazy-validation @submit.prevent="addNewDetails">
        <v-card tile>
          <v-toolbar dark color="primary" dense flat class="max-height">
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text"> Editar {{ detalle.concepto }} </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="py-2">
            <v-data-table class="py-2" :headers="headers" :items="items" hide-default-footer disable-pagination>
              <template v-slot:top>
                <p class="h4 text-center text-primary">{{ `Nuevo Detalle`.toUpperCase() }}</p>
              </template>
              <template v-slot:[`item.monto`]="{ item }">
                <v-text-field
                  type="number"
                  v-model.number="item.monto_calculado"
                  outlined
                  dense
                  :rules="[
                    rules.required,
                    rules.loanMin,
                    rules.loanMax(item.monto_calculado, item.plan_cuota ? item.plan_cuota.monto + item.plan_cuota.monto : item.monto),
                  ]"
                  @keydown="updateTotal"
                  @change="updateTotal"
                  @focus="updateTotal"
                  @click="updateTotal"
                  @input="updateTotal"
                ></v-text-field>
              </template>
              <template v-slot:[`item.select`]="{ item }">
                <v-select
                  v-model="item.plan_cuota"
                  :items="plan_pagos"
                  :rules="[rules.required]"
                  item-text="name"
                  outlined
                  dense
                  hint="Seleccione una cuota del plan para reemplazar el pago"
                  return-object
                  @change="
                    (item.numero_cuota = item.plan_cuota.numero_cuota),
                      (item.cuota_id = item.plan_cuota.optional ? null : item.plan_cuota.id),
                      (item.concepto_name = item.plan_cuota.concepto),
                      (item.concepto_pago_id = item.plan_cuota.concepto_pago_id)
                  "
                >
                </v-select>
              </template>
              <template v-slot:footer>
                <v-row justify="center" class="mx-2">
                  <v-col md="4" sm="6" xl="12">
                    <v-text-field v-model="old_total" readonly outlined dense label="Monto inicial a igualar"></v-text-field>
                  </v-col>
                  <v-col md="4" sm="6" xl="12">
                    <v-text-field
                      v-model="new_total"
                      outlined
                      dense
                      readonly
                      :rules="[rules.required, rules.loanMin, rules.loanMinTwo(new_total, old_total)]"
                      label="TOTAL DE NUEVO DETALLE"
                    ></v-text-field
                  ></v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-text-field
              v-model="number"
              class="w-20"
              outlined
              autofocus
              dense
              aria-multiline=""
              :rules="[rules.required, rules.loanMin]"
              label="Dividir En"
              type="number"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="dark" v-if="old_total === new_total" outlined rounded small>
              <v-icon class="mr-1"> mdi-eye</v-icon> Previsualizar
            </v-btn>
            <v-btn color="blue darken-1" outlined rounded small @click="cancel"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || 'Se requiere un valor',
        loanMin: (value) => value >= 1 || 'Valor debe ser mayor a 0',
        loanMinTwo: (monto, bs) => monto == bs || 'Monto no puede ser Diferente de ' + bs,
        loanMax: (monto, saldo) => monto <= saldo || 'Monto no puede ser mayor de ' + saldo,
      },
      dialog: false,
      detalle: null,
      valid: false,
      number: 0,
      old_total: 0,
      new_total: 0,
      items: [],
      plan_pagos: [],
      headers: [
        { text: 'Concepto', value: 'concepto_name' },
        { text: 'N° Cuota', value: 'numero_cuota' },
        { text: 'Monto', value: 'monto' },
        { text: 'Saldo', value: 'plan_cuota.saldo' },
        { text: 'Cuota Plan', value: 'select' },
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
    number(val) {
      if (100 > val > 0 && this.detalle) {
        var intvalue = Math.trunc(this.old_total / val);
        this.items = [];
        for (let i = 0; i < val; i++) this.items.push({ ...this.detalle, monto_calculado: intvalue, id: `${i + 1}${this.detalle.id}` });
        this.updateTotal();
      }
    },
  },
  methods: {
    showThisView(detalle, PlanPagos) {
      this.dialog = true;
      this.detalle = detalle;
      this.plan_pagos = PlanPagos;
      this.old_total = this.detalle.monto;
      // window.console.log(this.detalle, this.plan_pagos);
      this.number = 1;
    },
    updateTotal() {
      this.new_total = 0;
      this.items.forEach((item) => (this.new_total += +item.monto_calculado));
    },
    addNewDetails() {
      if (this.$refs.formDivider.validate()) {
        this.$emit('addNewDetails', this.items, this.detalle);
        this.closeDialog();
      }
    },
    cancel() {
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.valid = false;
      this.detalle = null;
      this.number = 0;
      this.old_total = 0;
      this.new_total = 0;
      this.items = [];
      this.plan_pagos = [];
    },
  },
};
</script>
<style scoped>
.w-10 {
  max-width: 10%;
}
.w-20 {
  max-width: 20%;
}
</style>